import { Routes, RouterModule } from '@angular/router';
import { ProductsComponent } from './products.component';
import { MainComponent } from '../main/main.component';

const routes: Routes = [
  { 
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'productos',
        component: ProductsComponent
      },
      {
        path: 'productos/:id',
        component: ProductsComponent
      }
    ]  
  },
];

export const ProductsRoutes = RouterModule.forChild(routes);
